import { useLazySwiper } from '@/hooks/use-swiper-lazy';
import { SwiperSlide } from 'swiper/react';
import { Swiper } from 'swiper/types';
import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { Thumbs } from 'swiper/modules';
import classNames from 'classnames';

type ThumbsContextType = {
    thumbsSwiper: Swiper | null;
    setThumbsSwiper: Dispatch<SetStateAction<Swiper | null>>;
};

const ThumbsContext = createContext<ThumbsContextType>({
    thumbsSwiper: null,
    setThumbsSwiper: () => {},
});

export const ThumbsProvider = ({ children }: { children: ReactNode }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState<Swiper | null>(null);

    return <ThumbsContext.Provider value={{ thumbsSwiper, setThumbsSwiper }}>{children}</ThumbsContext.Provider>;
};

export const useThumbs = () => useContext(ThumbsContext);

type Props = {
    imagesCount: number;
};

const ThumbsSlider = ({ imagesCount }: Props) => {
    const { Swiper } = useLazySwiper({ useSwiper: true });
    const { setThumbsSwiper } = useThumbs();

    const slides = Array.from({ length: imagesCount }, (_, index) => index);

    return (
        <Swiper
            modules={[Thumbs]}
            onSwiper={setThumbsSwiper}
            slidesPerView={5}
            spaceBetween={5}
            watchSlidesProgress
            className={classNames('card-thumbs', { 'is-center': slides.length < 4 })}
        >
            {slides.length > 1 &&
                slides.map((_, i) => (
                    <SwiperSlide key={`thumb-${i}`} className="card-thumbs__slide" onClick={(e) => e.preventDefault()}>
                        <div className="card-thumbs__line" />
                    </SwiperSlide>
                ))}
        </Swiper>
    );
};

export default ThumbsSlider;
